import { httpClient } from '../lib/http-client';
import { Notificacao } from '../types';

/**
 * Service para gerenciamento de notificações
 */
export class NotificacoesService {
  static async getNotificacoes(
    limit: number = 50
  ): Promise<{ success: boolean; notificacoes: Notificacao[] }> {
    try {
      const response = await httpClient.getInstance().get(`/api/notificacoes?limit=${limit}`);
      return response.data;
    } catch (error: any) {
      console.error('Erro ao buscar notificações:', error);
      throw new Error(error.response?.data?.error || 'Erro ao buscar notificações');
    }
  }

  static async verificarNotificacoesTicket(
    ticketId: number
  ): Promise<{ success: boolean; tem_notificacoes: boolean }> {
    try {
      const response = await httpClient.getInstance().get(
        `/api/notificacoes/ticket/${ticketId}/verificar`
      );
      return response.data;
    } catch (error: any) {
      console.error('Erro ao verificar notificações do ticket:', error);
      throw new Error(
        error.response?.data?.error || 'Erro ao verificar notificações do ticket'
      );
    }
  }

  static async getNotificacoesNaoLidas(
    limit: number = 20
  ): Promise<{ success: boolean; notificacoes: Notificacao[] }> {
    return httpClient.get<{ success: boolean; notificacoes: Notificacao[] }>(
      '/api/notificacoes/nao-lidas',
      { params: { limit } }
    );
  }

  static async contarNotificacoesNaoLidas(): Promise<{ success: boolean; total: number }> {
    return httpClient.get<{ success: boolean; total: number }>('/api/notificacoes/contar');
  }

  static async marcarNotificacaoComoLida(
    id: number
  ): Promise<{ success: boolean; message: string }> {
    return httpClient.patch<{ success: boolean; message: string }>(
      `/api/notificacoes/${id}/marcar-lida`
    );
  }

  static async marcarTodasNotificacoesComoLidas(): Promise<{
    success: boolean;
    message: string;
  }> {
    return httpClient.patch<{ success: boolean; message: string }>(
      '/api/notificacoes/marcar-todas-lidas'
    );
  }

  static async criarNotificacao(data: {
    tipo: string;
    usuario_id: number;
    ticket_id?: number;
    mensagem: string;
  }): Promise<{ success: boolean; message: string; notificacao: any }> {
    return httpClient.post<{ success: boolean; message: string; notificacao: any }>(
      '/api/notificacoes',
      data
    );
  }

  static async deletarNotificacao(id: number): Promise<{ success: boolean; message: string }> {
    return httpClient.delete<{ success: boolean; message: string }>(`/api/notificacoes/${id}`);
  }
}

